import React from "react";
import { useApp } from "@/context/AppContext";
import { ProgressRing } from "@/components/ProgressRing";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";

export function ProgressCard() {
  const { state, totals, daily, progress, streak } = useApp();

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
      className="relative overflow-hidden rounded-[22px] mb-6 p-5 sm:p-6"
      style={{
        background: "rgba(14, 14, 20, 0.92)",
        border: "1px solid rgba(10,133,255,0.14)",
        backdropFilter: "blur(48px)",
        boxShadow: "0 2px 24px rgba(0,0,0,0.5), 0 1px 0 rgba(10,133,255,0.08) inset",
      }}
    >
      {/* Subtle blue gradient top-left */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 0% 0%, rgba(10,133,255,0.10) 0%, transparent 60%)" }}
      />

      <div className="relative z-[1] flex items-center gap-5">
        {/* Ring — left side */}
        <ProgressRing
          size={108}
          strokeWidth={9}
          progress={progress}
          done={totals.done}
          total={totals.total}
        />

        {/* Stats — right side */}
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-semibold text-primary/70 uppercase tracking-[0.18em] mb-1">
            Semana {state?.week || 1}
          </p>

          <h2 className="text-white font-bold text-xl tracking-tight leading-tight mb-3">
            {totals.done === totals.total && totals.total > 0
              ? "¡Todo completado!"
              : `${totals.total - totals.done} series`}
          </h2>

          {/* Metrics row */}
          <div className="flex flex-col gap-1.5">
            <div className="flex items-center justify-between">
              <span className="text-white/40 text-xs font-medium">Semana</span>
              <span className="text-white font-semibold text-sm tabular-nums">{totals.done}<span className="text-white/35 font-normal">/{totals.total}</span></span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-white/40 text-xs font-medium">Hoy</span>
              <span className="text-success font-semibold text-sm tabular-nums">{daily.done}<span className="text-white/35 font-normal">/{daily.total}</span></span>
            </div>
            {streak > 0 && (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="flex items-center justify-between mt-0.5"
              >
                <span className="text-white/40 text-xs font-medium">Racha</span>
                <div className="flex items-center gap-1">
                  <Flame className="h-3.5 w-3.5 text-orange-400" />
                  <span className="text-orange-400 font-bold text-sm tabular-nums">{streak}</span>
                  <span className="text-orange-400/60 text-xs">{streak === 1 ? "día" : "días"}</span>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
